<template>
    <div class="text-gray-500 text-xs italic">
        <slot></slot>
    </div>
</template>
<script>
export default {};
</script>
